export const whiteColor = "#ffffff";
export const blackColor = "#000000";
export const grayColor = "#424242";
export const lightGrayColor = "#9e9e9e";
export const secondaryColor = "#ff1493";
export const accentColor = "#bced09";
export const offWhiteColor = "#fafafa";
export const purpleColor = "#bc13fe";
